import type { ArtistLinkPagePopularSong } from "@libs/link-in-bio-config";

/** An unserved album has display-only tracks, except for its active exclusives. */
export function albumTracksForAvailability(
  tracks: readonly ArtistLinkPagePopularSong[],
  availableOnLissen: boolean,
): ArtistLinkPagePopularSong[] {
  return tracks.map((track) =>
    availableOnLissen || track.musicAccessId
      ? track
      : {
          ...track,
          albumId: null,
          previewUrl: null,
          platformLinks: track.platformLinks.filter(
            (link) => link.type !== "lissen",
          ),
        },
  );
}
